// @flow
import {useWatch} from 'react-hook-form';
import {useDebounce} from '../../../utils/react';
import {endpoints} from '../api';

import type {Control} from 'react-hook-form';

import clFlagIcon from '../../../../node_modules/flag-icon-css/flags/1x1/cl.svg';
import arFlagIcon from '../../../../node_modules/flag-icon-css/flags/1x1/ar.svg';
import mxFlagIcon from '../../../../node_modules/flag-icon-css/flags/1x1/mx.svg';
import brFlagIcon from '../../../../node_modules/flag-icon-css/flags/1x1/br.svg';
import ecFlagIcon from '../../../../node_modules/flag-icon-css/flags/1x1/ec.svg';
import boFlagIcon from '../../../../node_modules/flag-icon-css/flags/1x1/bo.svg';
import uyFlagIcon from '../../../../node_modules/flag-icon-css/flags/1x1/uy.svg';
import pyFlagIcon from '../../../../node_modules/flag-icon-css/flags/1x1/py.svg';
import usFlagIcon from '../../../../node_modules/flag-icon-css/flags/1x1/us.svg';
import peFlagIcon from '../../../../node_modules/flag-icon-css/flags/1x1/pe.svg';
import coFlagIcon from '../../../../node_modules/flag-icon-css/flags/1x1/co.svg';
import esFlagIcon from '../../../../node_modules/flag-icon-css/flags/1x1/es.svg';
import gtFlagIcon from '../../../../node_modules/flag-icon-css/flags/1x1/gt.svg';
import crFlagIcon from '../../../../node_modules/flag-icon-css/flags/1x1/cr.svg';
import hnFlagIcon from '../../../../node_modules/flag-icon-css/flags/1x1/hn.svg';
import svFlagIcon from '../../../../node_modules/flag-icon-css/flags/1x1/sv.svg';
import niFlagIcon from '../../../../node_modules/flag-icon-css/flags/1x1/ni.svg';
import doFlagIcon from '../../../../node_modules/flag-icon-css/flags/1x1/do.svg';
import paFlagIcon from '../../../../node_modules/flag-icon-css/flags/1x1/pa.svg';
import veFlagIcon from '../../../../node_modules/flag-icon-css/flags/1x1/ve.svg';

export const rgxCountries = {
  CL: /^[0-9]{7,9}$/,
  AR: /^[0-9]{7,10}$/,
  MX: /^[0-9]{7,10}$/,
  BR: /^[0-9]{7,8}$/,
  EC: /^[0-9]{8,9}$/,
  BO: /^[0-9]{7,8}$/,
  UY: /^[0-9]{7,8}$/,
  PY: /^[0-9]{8,10}$/,
  US: /^[0-9]{7,10}$/,
  PE: /^[0-9]{7,9}$/,
  CO: /^[0-9]{7,10}$/,
  DEFAULT: /^[0-9]{6,15}$/,
};

export function transformDomain(domain: string): string {
  if (typeof domain.normalize === 'function') {
    return domain
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-zA-Z0-9]+/g, '');
  }
  return domain
    .toLowerCase()
    .replace('á', 'a')
    .replace('é', 'e')
    .replace('í', 'i')
    .replace('ó', 'o')
    .replace('ú', 'u')
    .replace('ä', 'a')
    .replace('ë', 'e')
    .replace('î', 'i')
    .replace('ö', 'o')
    .replace('ü', 'u')
    .replace('à', 'a')
    .replace('è', 'e')
    .replace('ì', 'i')
    .replace('ò', 'o')
    .replace('ù', 'u')
    .replace('ñ', 'n')
    .replace(/[^a-zA-Z0-9]+/g, '');
}

export const useDebounceInput = (
  control: Control,
  name: string,
  defaultValue: string,
  debounceTime?: number
) => {
  const value = useWatch({
    control,
    name,
    defaultValue,
  });
  return useDebounce(value, debounceTime);
};

export function getFlagCountryByCurrency(currencyCode: string) {
  switch (currencyCode) {
    case 'CLP':
      return clFlagIcon;
    case 'ARS':
      return arFlagIcon;
    case 'MXN':
      return mxFlagIcon;
    case 'BRL':
      return brFlagIcon;
    // case 'EC':
    //   return ecFlagIcon;
    case 'BOB':
      return boFlagIcon;
    case 'UYU':
      return uyFlagIcon;
    case 'PYG':
      return pyFlagIcon;
    case 'USD':
      return usFlagIcon;
    case 'PEN':
      return peFlagIcon;
    case 'COP':
      return coFlagIcon;
    case 'EUR':
      return esFlagIcon;
    case 'GTQ':
      return gtFlagIcon;
    case 'CRC':
      return crFlagIcon;
    case 'HNL':
      return hnFlagIcon;
    // case 'SV':
    //   return svFlagIcon;
    case 'NIO':
      return niFlagIcon;
    case 'DOP':
      return doFlagIcon;
    case 'PAB':
      return paFlagIcon;
    case 'VES':
      return veFlagIcon;
    default:
      return peFlagIcon;
  }
}

export function getFlagByCountryCode(countryCode: string) {
  // return getFlagCountryByCurrency(getCurrencyByCountry(countryCode));
  switch (countryCode) {
    case 'CL':
      return clFlagIcon;
    case 'AR':
      return arFlagIcon;
    case 'MX':
      return mxFlagIcon;
    case 'BR':
      return brFlagIcon;
    case 'EC':
      return ecFlagIcon;
    case 'BO':
      return boFlagIcon;
    case 'UY':
      return uyFlagIcon;
    case 'PY':
      return pyFlagIcon;
    case 'US':
      return usFlagIcon;
    case 'PE':
      return peFlagIcon;
    case 'CO':
      return coFlagIcon;
    case 'ES':
      return esFlagIcon;
    case 'GT':
      return gtFlagIcon;
    case 'CR':
      return crFlagIcon;
    case 'HN':
      return hnFlagIcon;
    case 'SV':
      return svFlagIcon;
    case 'NI':
      return niFlagIcon;
    case 'DO':
      return doFlagIcon;
    case 'PA':
      return paFlagIcon;
    case 'VE':
      return veFlagIcon;
    default:
      return peFlagIcon;
  }
}

export function getCurrencyInSpanish(currencyCode: string) {
  switch (currencyCode) {
    case 'CLP':
      return 'Peso Chileno';
    case 'ARS':
      return 'Peso Argentino';
    case 'MXN':
      return 'Peso Mexicano';
    case 'BRL':
      return 'Real Brasileño';
    // case 'EC':
    //   return ecFlagIcon;
    case 'BOB':
      return 'Peso Boliviano';
    case 'UYU':
      return 'Peso Uruguayo';
    case 'PYG':
      return 'Guaraní';
    case 'USD':
      return 'Dolar Estadounidense';
    case 'PEN':
      return 'Sol Peruano';
    case 'COP':
      return 'Peso Colombiano';
    case 'EUR':
      return 'Euro';
    case 'GTQ':
      return 'Quetsal Guatemalteco';
    case 'CRC':
      return 'Colón Costarricense';
    case 'HNL':
      return 'Lempira Hondureño';
    // case 'SV':
    //   return svFlagIcon;
    case 'NIO':
      return 'Córdova Nicaraguense';
    case 'DOP':
      return 'Peso Dominicano';
    case 'PAB':
      return 'Balboa Panameño';
    case 'VES':
      return 'Bolívar Venezolano';
    default:
      return 'Sol Peruano';
  }
}

export function getCountryInSpanish(countryCode: string) {
  switch (countryCode) {
    case 'CL':
      return 'Chile';
    case 'AR':
      return 'Argentina';
    case 'MX':
      return 'México';
    case 'BR':
      return 'Brasil';
    case 'EC':
      return 'Ecuador';
    case 'BO':
      return 'Bolivia';
    case 'UY':
      return 'Uruguay';
    case 'PY':
      return 'Paraguay';
    case 'US':
      return 'Estados Unidos';
    case 'PE':
      return 'Perú';
    case 'CO':
      return 'Colombia';
    case 'ES':
      return 'España';
    case 'GT':
      return 'Guatemala';
    case 'CR':
      return 'Costa Rica';
    case 'HN':
      return 'Honduras';
    case 'SV':
      return 'El Salvador';
    case 'NI':
      return 'Nicaragua';
    case 'DO':
      return 'República Dominicana';
    case 'PA':
      return 'Panamá';
    case 'VE':
      return 'Venezuela';
    default:
      return 'Perú';
  }
}

export function getCurrencyByCountry(countryCode: string) {
  switch (countryCode) {
    case 'US':
      return 'USD';
    case 'PE':
      return 'PEN';
    case 'CO':
      return 'COP';
    case 'MX':
      return 'MXN';
    case 'CL':
      return 'CLP';
    case 'AR':
      return 'ARS';
    case 'BR':
      return 'BRL';
    case 'EC':
      return 'USD';
    case 'BO':
      return 'BOB';
    case 'UY':
      return 'UYU';
    case 'PY':
      return 'PYG';
    case 'ES':
      return 'EUR';
    case 'GT':
      return 'GTQ';
    case 'CR':
      return 'CRC';
    case 'HN':
      return 'HNL';
    case 'SV':
      return 'USD';
    case 'NI':
      return 'NIO';
    case 'DO':
      return 'DOP';
    case 'PA':
      return 'PAB';
    case 'VE':
      return 'VES';
    default:
      return 'PE';
  }
}

export const validateDomain = async (subdomain: string) => {
  const response = await fetch(`${endpoints.VALIDATE_DOMAIN}`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({subdomainName: subdomain}),
  });
  return response.json();
};
